import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import AllowableDetailContainer from "../User/AllowableDetailContainer";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNotifyContext } from "components/Notify";

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: "capitalize",
  },
  actionColumn: {
    "& button": {
      margin: theme.spacing(1),
      marginLeft: theme.spacing(0),
    },
  },
  tableStyle: {
    "& .MuiGrid-item": {
      borderBottom: "1px solid gray",
    },
  },
  inputStyle: {
    marginTop: theme.spacing(1),
  },
}));

const AllowableEstateDetails = (props) => {
  const { t } = useTranslation();
  const { allowables, setAllowables,setIsButtonDisabled,isButtonDisabled, renderOnly } = props;

  const classes = useStyles();
  const setNotify = useNotifyContext();

  const addNewAllowables = () => {
    const allowablesWithConfirmedFalse = allowables.filter(
      (allowables) => allowables.confirmed === false
    );
    if (allowablesWithConfirmedFalse.length > 0) {
      setNotify({
        isOpen: true,
        message:
          "Please confirm the unconfirmed changes before adding new record.",
        type: "error",
      });
      return;
    }
    let id = allowables.length + 1;
    setAllowables([...allowables, {
        id : id,
        zones: null,
        regions: null,
        estates: null,
        confirmed: false,
        editMode : true
      }]);
  };

  return renderOnly ? (
    <Grid container spacing={2}>
      <Grid item container direction="row" spacing={1} xs={12}>
      <Grid
          item
          container
          direction="row"
          spacing={2}
          xs={12}
          className={classes.tableStyle}
        >
          <Grid item lg={3}>
            {t("Choose Zone")} <span style={{ color: "red" }}>*</span>
          </Grid>
          <Grid item lg={3}>
            <span>
              {t("Choose Region")} <span style={{ color: "red" }}>*</span>
            </span>
          </Grid>
          <Grid item lg={3}>
            <span>{t("Choose Estate")}<span style={{ color: "red" }}>*</span>
            </span>
          </Grid>
          <Grid item lg={3}>
            <span>{t("Action")}</span>
          </Grid>
        </Grid>
        {allowables.map((data) => {
          return (
            <AllowableDetailContainer
              key={data.id}
              data={data}
              allowables={allowables}
              setAllowables={setAllowables}
              isButtonDisabled = {isButtonDisabled}
              setIsButtonDisabled = {setIsButtonDisabled}
              classes={classes}
              renderOnly={renderOnly}
            />
          );
        })}
      </Grid>
    </Grid>
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={addNewAllowables}
          color="primary"
          disabled = {isButtonDisabled}
          className={classes.button}
        >
          {t("Add New")}
        </Button>
      </Grid>

      <Grid item container direction="row" spacing={1} xs={12}>
        <Grid
          item
          container
          direction="row"
          spacing={2}
          xs={12}
          className={classes.tableStyle}
        >
          <Grid item lg={3}>
            {t("Choose Zone")} <span style={{ color: "red" }}>*</span>
          </Grid>
          <Grid item lg={3}>
            <span>
              {t("Choose Region")} <span style={{ color: "red" }}>*</span>
            </span>
          </Grid>
          <Grid item lg={3}>
            <span>{t("Choose Estate")}<span style={{ color: "red" }}>*</span>
            </span>
          </Grid>
          <Grid item lg={3}>
            <span>{t("Action")}</span>
          </Grid>
        </Grid>
        {/* {JSON.stringify(allowables)} */}

        {allowables.map((data,id) => {
          return (
            <AllowableDetailContainer
              key={id}
              // data={data}
              id={id}
              allowables={allowables}
              setAllowables={setAllowables}
              isButtonDisabled={isButtonDisabled}
              setIsButtonDisabled={setIsButtonDisabled}
              classes={classes}
            />
          );
        })}
      </Grid>
    </Grid>
  );
};
AllowableEstateDetails.propTypes = {
  allowables: PropTypes.array,
  setAllowables: PropTypes.func,
  isButtonDisabled: PropTypes.bool,
  setIsButtonDisabled: PropTypes.func,
  id:PropTypes.string,
  renderOnly: PropTypes.bool,
};

export default AllowableEstateDetails;
